(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-impact"] && !Shopify.designMode) return;
  try {
    
function bbWelcomeInit(root) {
  const dialogs = root.querySelectorAll('[data-bb-welcome]');
  dialogs.forEach((dialog) => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const dismiss = () => dialog.close();
    dialog.querySelectorAll('[data-bb-dismiss]').forEach((button) => button.addEventListener('click', dismiss));
    dialog.querySelector('[data-bb-shop]').addEventListener('click', () => {
      dialog.close();
      const shortcut = dialog.parentElement.querySelector('.bb-shortcuts');
      if (shortcut) {
        shortcut.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        const first = shortcut.querySelector('a');
        if (first) first.focus({ preventScroll: true });
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
    });
    if (!dialog.open) dialog.showModal();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bbWelcomeInit(document), { once: true });
} else {
  bbWelcomeInit(document);
}
document.addEventListener('shopify:section:load', (event) => bbWelcomeInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
